import React from "react";
import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";
import styled from "@emotion/styled";

import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

import { Button } from "../../UI/Button";
import { COLOR_MISCHKA } from "../../constants/styles";

interface IProps {
  handleDelete: VoidFunction;
  isLoading?: boolean;
  isDisabled?: boolean;
}

const StyledButton = styled(Button)`
  min-width: 32px;
  min-height: 32px;
  border: 1px solid ${COLOR_MISCHKA} !important;
  padding: 0;
`;

export const DeleteButton: React.FC<IProps> = (props) => (
  <ReadOnlyWrapper>
    <StyledButton
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
      appearance="subtle"
      iconAfter={<EditorRemoveIcon label="Delete" />}
      onClick={props.handleDelete}
    />
  </ReadOnlyWrapper>
);

DeleteButton.defaultProps = {
  isLoading: false,
};
